import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import LoanPropertyUpdateModalSF from './LoanPropertyUpdateModalSF'
import LoanPropertyMultiUpdateModalSF from './LoanPropertyMultiUpdateModalSF'
import './LoanPropertyList.css'

const LoanProperty2ListUI = ({ context, propertyList, errorList, loan,
  // modes
  updateMode, multiUpdateMode, selectedProperty, selectedPropertyGroup, categoryLabel,
  // event handlers
  onRefreshClick, onUpdateClick, onCancelClick, onMultiCancelClick
}) =>
  propertyList.length > 0 &&
  <CardUI className='su_l_props g_m_top_100' title={categoryLabel} noUnderline={true}>
    <LRTableBodyUI>
      {
        propertyList.map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} i={i} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick} />}
          />
        )
      }
    </LRTableBodyUI>

    <LoanPropertyUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedProperty={selectedProperty}
      loan={loan}
    />

    <LoanPropertyMultiUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={multiUpdateMode}
      onCancelClick={onMultiCancelClick}
      onRefreshClick={onRefreshClick}
      propertyGroup={selectedPropertyGroup}
      propertyList={propertyList}
      loan={loan}
    />
  </CardUI>

const RowLeftUI = ({ context, i, property }) =>
  <div className='g_flex_h g_flex_left'>
    {
      property.propertyCode !== 'term_sheet_special_terms' &&
      <>
        <span className='g_m_right_50'>
          {i + 1}.
        </span>
        <span>
          {property.propertyName}<br />
          {
            property.hint &&
            <span className='g_muted g_small'>{property.hint}</span>
          }
        </span>
      </>
    }
  </div>

const RowRightUI = ({ property, onUpdateClick }) =>
  <div className={`g_flex_h g_m_left_100 g_flex_top g_flex_right
      ${property.propertyCode != 'term_sheet_special_terms' ? 'right1' : ''}`}>
    {
      property.propertyCode === 'ev_parking_premise' &&
      <span className='wrap'>{getParkingPremiseDisplay(property.propertyValue || property.defaultValue)}</span>
    }
    {
      property.propertyCode !== 'ev_parking_premise' && property.propertyType !== 'boolean_' &&
      <span className='wrap'>{property.propertyValue || property.defaultValue}</span>
    }
    {
      property.propertyCode !== 'ev_parking_premise' && property.propertyType === 'boolean_' &&
      <span>{property.propertyValue != null ? (property.propertyValue === '1' ? 'Yes' : 'No') :
        (property.defaultValue === '1' ? 'Yes' : 'No')}</span>
    }
    <span className='icon icon-pencil g_link_2 g_m_left_50'
      data-property={property.propertyCode} onClick={onUpdateClick} />
  </div>

const getParkingPremiseDisplay = (value) => {
  if (!value)
    return ''
  try {
    let parsed = JSON.parse(value)
    if (!Array.isArray(parsed) || parsed.length === 0)
      return ''
    return parsed.length === 1 ? '1 location' : (parsed.length + ' locations')
  } catch (e) {
    return value
  }
}

export default LoanProperty2ListUI
